import { render, staticRenderFns } from "./powerDetail.vue?vue&type=template&id=24bd1bba&scoped=true"
import script from "./powerDetail.vue?vue&type=script&lang=js"
export * from "./powerDetail.vue?vue&type=script&lang=js"
import style0 from "./powerDetail.vue?vue&type=style&index=0&id=24bd1bba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bd1bba",
  null
  
)

export default component.exports